export const SEATS_SSR_CODES = {
  SEAT_FIRST_ROW: "ST1",
  SEAT_BUNDLE1_FEE: "STB1",
  SEAT_PREMIUM_BUNDLE_FEE: "STB2",
  SEAT_STANDARD_BACK: "STBK", // rows 15–32
  SEAT_EMERGENCY_EXIT: "STEX", // row 14
  SEAT_STANDARD_FRONT: "STFW", // rows 5–11
  SEAT_SMART: "STSM", // rows 2–4
} as const;

export const SSR_CODES = {
  FLEXI: "FLXB",
  PRIORITY_BOARDING: "PBD",
  BOARDING_PASS: "APCD", // OR APCF
  PET_ON_BOARD: "PTCD",
  TRAVEL_INSURANCE: "TIF",
  BAGD: "BAGD",
  LIGHT_BAGGAGE: "LBGD",
  SPECIAL_BAGGAGE: "SPQD",
  BAGC: "BAGC",
  BOARDING_PASS_DURING_BOOKING: "APCD",
  ...SEATS_SSR_CODES,
} as const;

export const SSR_CODES_CHECKIN = {
  FLEXI: "FLXB",
  PRIORITY_BOARDING: "PBP", // checkin code for priority boarding
  BOARDING_PASS: "APCP", // checkin code for boarding pass
  PET_ON_BOARD: "PTCP", // checkin code for pet on board
  TRAVEL_INSURANCE: "TIF",
} as const;
